module.exports = __webpack_public_path__ + "static/privaliaLogo-4c0971b84edbfdf544eb38bf6a1aaa71.svg";